export default "__VITE_ASSET__893H_vHe__"